<template>
    <b-modal id="resetCachesModal" :title="$t('resetCaches.title')" v-on:hide="onHide" ok-only>

        <b-alert v-model="showError" variant="danger" dismissible>
            {{ errorMsg }}
        </b-alert>

        <b-alert v-model="showSuccess" variant="success" dismissible>
            {{ successMsg }}
        </b-alert>

        <b-container>
            <b-row>
                <b-col class="padding">
                    <b-button variant="outline-primary" block v-on:click="resetCache(resetObj.productTree)">
                        {{ $t('resetCaches.productStructure') }}
                        <span v-if="resetObj.productTree.isLoading">
                            <b-spinner :small="true"/>
                        </span>
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="padding">
                    <b-button variant="outline-primary" block v-on:click="resetCache(resetObj.productPics)">
                        {{ $t('resetCaches.productPictures') }}
                        <span v-if="resetObj.productPics.isLoading">
                            <b-spinner :small="true"/>
                        </span>
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="padding">
                    <b-button variant="outline-primary" block v-on:click="resetCache(resetObj.ruleService)">
                        {{ $t('resetCaches.partListRuleFiles') }}
                        <span v-if="resetObj.ruleService.isLoading">
                            <b-spinner :small="true"/>
                        </span>
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="padding">
                    <b-button variant="outline-primary" block v-on:click="resetCache(resetObj.textSystem)">
                        {{ $t('resetCaches.textSystem') }}
                        <span v-if="resetObj.textSystem.isLoading">
                            <b-spinner :small="true"/>
                        </span>
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="padding">
                    <b-button variant="outline-primary" block v-on:click="resetCache(resetObj.userManagement)">
                        {{ $t('resetCaches.userManagement') }}
                        <span v-if="resetObj.userManagement.isLoading">
                            <b-spinner :small="true"/>
                        </span>
                    </b-button>
                </b-col>
            </b-row>
        </b-container>

        <b-container>
          <b-row v-for="validationMessages in validationMessagesList" :key="validationMessages.maxStklId">
            <b-alert show :variant="(validationMessages.containsError)? 'error' : (validationMessages.containsWarning? 'warning' : 'success')">
              <h4 class="alert-heading">{{validationMessages.maxStklId}}: {{validationMessages.benennung}}</h4>
              <ul>
                  <li v-for="(message, index) in validationMessages.messages" :key="index">
                    {{message.severity}} {{message.source}} {{message.sheet}}: {{message.message}} ({{message.detail}})
                  </li>
              </ul>
            </b-alert>
          </b-row>
        </b-container>

    </b-modal>
</template>

<script>
    import pdm from '@/rest/pdm.js';
    import url from '@/rest/url';
    import isEmpty from "@/mixins/isempty";

    export default {
        name: "ResetCachesModal",
        data: function() {
            return {
                urls: url,
                errorMsg: '',
                successMsg: '',
                validationMessagesList: [],
                showError: false,
                showSuccess: false,
                resetObj: {
                    productTree:    {isLoading: false, url: url.resetProcutTreeURL},
                    productPics:    {isLoading: false, url: url.resetProductPicsURL},
                    ruleService:    {isLoading: false, url: url.resetRuleServiceURL},
                    textSystem:     {isLoading: false, url: url.resetTextSystemURL},
                    userManagement: {isLoading: false, url: url.resetUserMangementURL}
                }
            }
        },
        mixins: [isEmpty],
        methods: {
            resetCache(resetObj) {
                resetObj.isLoading = true;
                pdm.resetCache(resetObj.url).then((response) => {
                    this.successMsg = this.$t('resetCaches.success');
                    this.showSuccess = true;
                    let responseData = response.data;
                    //alert(responseData);
                    if (!this.isEmpty(responseData)) {
                      this.validationMessagesList = JSON.parse(responseData);
                    }
                }).catch(error => {
                    this.errorMsg = error.message;
                    this.showError = true;
                    this.validationMessagesList = [];
                }).finally(() => {
                    resetObj.isLoading = false;
                });
            },

            onHide() {
                this.showError = false;
                this.showSuccess = false;
                this.successMsg = '';
                this.errorMsg = '';
                this.validationMessagesList = [];
            }
        }
    }
</script>

<style scoped>

    .padding {
        padding-bottom: 20px;
    }

</style>